/* eslint-disable react/prop-types */
/* eslint-disable react/button-has-type */
import React from 'react';
import { toast } from 'react-toastify';
import axios from 'axios';
import PropTypes from 'prop-types';
import { getCookies } from '../../hooks/useCookies';
import styles from './onboard.module.scss';
import { SERVER_BASE_URL, ADMIN_STRIPE_ONBOARDING_URL } from '../../redux/apiConstants';

function OnboardExpress({ eventId }) {
  const [showPopup, setShowPopup] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState('');

  const email = getCookies('USEREMAIL');
  const userId = getCookies('USERID');

  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('onboarding') === 'true') {
      toast.success('Account is connected');
      params.delete('onboarding');
      const newSearch = params.toString();
      const newUrl = `${window.location.pathname}${newSearch ? `?${newSearch}` : ''}`;
      window.history.replaceState({}, '', newUrl);
    }
  }, []);

  const onboard = async () => {
    setLoading(true);
    setError('');
    try {
      const { data } = await axios.post(ADMIN_STRIPE_ONBOARDING_URL, {
        email,
        eventId,
      });
      const redirectUrl = data?.data?.url;
      if (redirectUrl) {
        window.location.href = redirectUrl;
      } else {
        setError('Failed to start onboarding.');
      }
    } catch (err) {
      setError('Failed to start onboarding.');
    } finally {
      setLoading(false);
    }
  };

  const checkAccountId = async () => {
    const headers = {
      'Access-Control-Allow-Origin': '*',
      Authorization: `Bearer ${getCookies('Token')}`,
    };
    setLoading(true);
    setError('');
    try {
      const res = await axios.get(`${SERVER_BASE_URL}/user/${userId}`, { headers });
      console.log(res);
      if (res.data?.data?.user && res.data?.data?.user?.accountId) {
        setShowPopup(true);
      } else {
        onboard();
      }
    } catch (err) {
      setError('Failed to check Stripe account.');
    } finally {
      setLoading(false);
    }
  };

  const handleUseExisting = async () => {
    setLoading(true);
    setError('');
    try {
      await axios.post(`${SERVER_BASE_URL}/booking/set-account`, {
        eventId,
        userId,
      });
      setShowPopup(false);
      toast.success('Existing Stripe account has been associated with this event.');
    } catch (err) {
      setError('Failed to associate existing account.');
    } finally {
      setLoading(false);
    }
  };

  const handleCreateNew = () => {
    setShowPopup(false);
    onboard();
  };

  return (
    <div>
      <button
        type="button"
        className={`${styles.addBtn_stl} addBtn`}
        onClick={checkAccountId}
        disabled={loading}
      >
        {loading ? 'Processing...' : 'Onboard with Stripe (Express)'}
      </button>
      {error && <div className={styles.error}>{error}</div>}
      {showPopup && (
        <div className={styles.modal}>
          <p>
            There is an account with this email. Do you want to add that to the event or create a
            new one?
          </p>
          <button
            className={styles.button}
            onClick={handleUseExisting}
            disabled={loading}
            style={{ marginRight: 10 }}
          >
            Use Existing
          </button>
          <button className={styles.button} onClick={handleCreateNew} disabled={loading}>
            Create New
          </button>
        </div>
      )}
    </div>
  );
}

OnboardExpress.propsType = {
  eventId: PropTypes.string.isRequired,
};

export default OnboardExpress;
